export default __webpack_public_path__ + "static/media/ch.49d277c9.svg";